module.exports = __webpack_public_path__ + "img/galactica_blueprints_04.5e5f7fb0.png";